import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexLists',
  setup(__props) {

const DefaultLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/DefaultLists.vue"))
const ActiveLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/ActiveLists.vue"))
const FlushLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/FlushLists.vue"))
const ContextualClasses = defineAsyncComponent(() => import("@/components/theme/uikits/lists/ContextualClasses.vue"))
const HorizontalLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/HorizontalLists.vue"))
const CustomList = defineAsyncComponent(() => import("@/components/theme/uikits/lists/CustomList.vue"))
const CheckboxRedio = defineAsyncComponent(() => import("@/components/theme/uikits/lists/CheckboxRedio.vue"))
const NumberList = defineAsyncComponent(() => import("@/components/theme/uikits/lists/NumberList.vue"))
const JavaScriptBehavior = defineAsyncComponent(() => import("@/components/theme/uikits/lists/JavaScriptBehavior.vue"))
const BadgeList = defineAsyncComponent(() => import("@/components/theme/uikits/lists/BadgeList.vue"))
const DisabledLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/DisabledLists.vue"))
const ScrollableLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/ScrollableLists.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      mains: "Lists",
      title: "Lists"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(DefaultLists)),
        _createVNode(_unref(ActiveLists)),
        _createVNode(_unref(FlushLists)),
        _createVNode(_unref(ContextualClasses)),
        _createVNode(_unref(HorizontalLists)),
        _createVNode(_unref(CustomList)),
        _createVNode(_unref(CheckboxRedio)),
        _createVNode(_unref(NumberList)),
        _createVNode(_unref(JavaScriptBehavior)),
        _createVNode(_unref(BadgeList)),
        _createVNode(_unref(DisabledLists)),
        _createVNode(_unref(ScrollableLists))
      ])
    ])
  ], 64))
}
}

})